import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription, Observable } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
import * as InvitationsActions from 'src/app/store/invitations/invitations.actions';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { selectInvitationsList } from 'src/app/store/invitations/invitations.selector';
import { Invitations } from 'src/app/model/invitations';
import { INVITATIONS_TYPE } from 'src/app/conf/invitations';

@Component({
	selector: 'app-invitations-dialog',
	templateUrl: './invitations-dialog.component.html',
	providers: [],
})

export class InvitationsDialogComponent implements OnInit, OnDestroy {
	invitationsList$: Observable<Invitations[] | undefined>;
	invitationsListSub: Subscription | undefined;
	invitationsList: Invitations[];

	pagingSub: Subscription;
	pageChangeSub: Subscription;
	pageSize: number = 10;
	resultLength: number;

	loading: boolean;

	GROUP_TH_SHARE = INVITATIONS_TYPE.GROUP_TH_SHARE;

	// design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	COLUMN_TITLE_MIN_WD = 647;
	acceptButtonStyle: string;
	rejectButtonStyle: string;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.invitationsList$ = this.store.select(selectInvitationsList);
	}

	ngOnInit(): void {
		this.invitationsListSub = this.invitationsList$?.subscribe(
			(invitationsList) => {
				this.invitationsList = invitationsList.filter(invit => invit.CreatorEmail !== undefined);
				this.resultLength = this.invitationsList.length;
			}
		);
		this.onResize();
	}

	ngOnDestroy(): void {
		this.invitationsListSub?.unsubscribe();
	}

	getInvitationsTypeTxt(invitation: Invitations): string {
		switch (invitation.Type) {
			case INVITATIONS_TYPE.DEVICE_SHARE: {
				return 'INVITATIONS_TYPE_DEVICE_SHARE';
			}
			case INVITATIONS_TYPE.TRANSFER_SITE: {
				return 'INVITATIONS_TYPE_TRANSFER_SITE';
			}
			case INVITATIONS_TYPE.ADD_CUSTOMER: {
				return 'INVITATIONS_TYPE_ADD_CUSTOMER';
			}
			case INVITATIONS_TYPE.GROUP_TH_SHARE: {
				return 'INVITATIONS_TYPE_GROUP_TH_SHARE';
			}
		}
		return '';
	}

	getInvitationsTypeIcon(invitation: Invitations): string {
		switch (invitation.Type) {
			case INVITATIONS_TYPE.DEVICE_SHARE: {
				return 'pi cm-devices';
			}
			case INVITATIONS_TYPE.TRANSFER_SITE: {
				return 'pi cm-installation';
			}
			case INVITATIONS_TYPE.ADD_CUSTOMER: {
				return 'pi cm-technician';
			}
			case INVITATIONS_TYPE.GROUP_TH_SHARE: {
				return 'pi cm-termo';
			}
		}
		return 'danger';
	}

	getInvitationsDetails(invitation: Invitations): string {
		switch (invitation.Type) {
			case INVITATIONS_TYPE.DEVICE_SHARE: {
				return this.translate.instant('DEVICE') + ': ' + invitation.DeviceName;
			}
			case INVITATIONS_TYPE.TRANSFER_SITE: {
				return this.translate.instant('INSTALLATION') + ': ' + invitation.SiteName;
			}
			case INVITATIONS_TYPE.ADD_CUSTOMER: {
				return this.translate.instant('ADD_CUSTOMER_TECNICIAN');
			}
			case INVITATIONS_TYPE.GROUP_TH_SHARE: {
				return this.translate.instant('TH_GROUP') + ': ' + invitation.MongoGroupName;
			}
		}
		return '';
	}

	getSenderTypeIcon(invitation: Invitations): string {
		switch (invitation.Type) {
			case INVITATIONS_TYPE.DEVICE_SHARE: {
				return 'pi cm-user';
			}
			case INVITATIONS_TYPE.TRANSFER_SITE: {
				return 'pi cm-technician';
			}
			case INVITATIONS_TYPE.ADD_CUSTOMER: {
				return 'pi cm-technician';
			}
			case INVITATIONS_TYPE.GROUP_TH_SHARE: {
				return 'pi cm-user';
			}
		}
		return '';
	}

	getSenderSeverity(invitation: Invitations): string {
		switch (invitation.Type) {
			case INVITATIONS_TYPE.DEVICE_SHARE: {
				return 'primary';
			}
			case INVITATIONS_TYPE.TRANSFER_SITE: {
				return 'warning';
			}
			case INVITATIONS_TYPE.ADD_CUSTOMER: {
				return 'warning';
			}
			case INVITATIONS_TYPE.GROUP_TH_SHARE: {
				return 'primary';
			}
		}
		return '';
	}

	acceptInvite(invitation: Invitations): void {
		this.store.dispatch(InvitationsActions.invitationsAccept({ token: invitation.Token }));
	}

	rejectInvite(invitation: Invitations): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('REJECT_INVITATION'),
			message: this.translate.instant('REJECT_INVITATION_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(InvitationsActions.invitationsReject({ token: invitation.Token }));
			},
			reject: () => {
			}
		});
	}

	closeDialog(): void {
		this.ref.close();
	}


	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	underTablet(): boolean {
		return this.screenWidth <= 960;
		// return StandardPageLayout.underTablet(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}
}
